<h1>Galerie - přidat obrázek</h1>

<gallery-uploader-feature (uploaded)="onUploaded()"></gallery-uploader-feature>